export const defaultData = {
  gasEngineerDetails: {
    engineerName: '',
    gasSafeId: '',
    engineerLicenceCardNo: '',
    companyName: '',
    companyAddress: '',
    telephone: ''
  },
  vehicleOwnerDetails: {
    businessTradingName: '',
    operatorName: '',
    vehicleRegOrVin: '',
    vehicleMakeModel: 'Catering Trailer / Food Truck',
    operatingBaseAddress: '',
    postCode: '',
    inspectionDate: new Date().toISOString().split('T')[0]
  },
  lpgStorageCompartment: {
    cylinderStorageType: 'External Sealed Compartment (30-min Fire Resistant)',
    compartmentVentilation: 'Satisfactory / Clear to Atmosphere',
    cylinderRestraints: 'Yes - Securely Strapped',
    changeoverRegulatorType: 'Clesse / Cavagna Automatic Changeover 37mbar OPSO/UPSO',
    pigtailHoseCondition: 'Pass - Within Service Date',
    emergencyIsolationValveAccessible: 'Yes - Clearly Marked'
  },
  vehicleStructureAndVentilation: {
    fireLiningSatisfactory: 'Satisfactory (Stainless Steel / Class 0)',
    canopyExtractionOperational: 'Yes - Mechanical Extraction',
    gasInterlockFitted: 'Yes - Interlock Verified',
    gasTightnessTestPass: 'Pass - Zero Pressure Drop',
    testPressureDropMbar: 0.0,
    coAlarmFitted: 'Yes - In Date & Tested'
  },
  appliances: {
    appliance1: 'Commercial 4-Burner LPG Range / Griddle',
    appliance1Ffd: 'Pass (FFD Closes <= 45s)',
    appliance1Visual: 'Pass',
    appliance2: 'Commercial Double Basket LPG Deep Fryer',
    appliance2Ffd: 'Pass (FFD Closes <= 45s)',
    appliance2Visual: 'Pass',
    appliance3: 'LPG Water Boiler / Bain Marie',
    appliance3Ffd: 'Pass (FFD Closes <= 45s)',
    appliance3Visual: 'Pass'
  },
  safetyNoticeAndSignOff: {
    overallResult: 'SAFE TO USE - SATISFACTORY',
    defectsNotes: 'All LPG pipework, cylinders, regulators and appliances tested. Flame failure devices verified on every burner.',
    nextInspectionDueDate: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    engineerSignature: '',
    operatorSignature: ''
  }
};

export default defaultData;
